export const INBOX_TYPE = {
  envInvite: 'EnvironmentInvitation',
  orgInvite: 'OrganizationInvitation',
  notification: 'Notification',
  workspaceTransfer: 'WorkspaceTransfer',
};

export const INBOX_NOTIFICATION_KIND = {
  appBuilderBeta: 'AppBuilderBeta',
};

export const INBOX_STATUS = {
  sent: 'sent',
  accepted: 'accepted',
  declined: 'declined',
};
